"use client";

import { createThirdwebClient, defineChain } from "thirdweb";
import {
  arbitrum,
  arbitrumSepolia,
  base,
  baseSepolia,
  bsc,
  bscTestnet,
  mainnet,
  sepolia,
} from "thirdweb/chains";
import {
  getGrowthPortalPublicConfig,
  resolveGrowthPortalClientEnv,
} from "./environment-config";

const env = resolveGrowthPortalClientEnv(process.env.NEXT_PUBLIC_CLIENT_ENV);

const growthChainsConfig = {
  dev: [baseSepolia, bscTestnet, arbitrumSepolia, sepolia],
  beta: [baseSepolia, bscTestnet, arbitrumSepolia, sepolia],
  prod: [mainnet, bsc, arbitrum, base],
};

const { thirdwebClientId: clientId, thirdwebSecretKey: secretKey } =
  getGrowthPortalPublicConfig(env);

const chainConfigKey: keyof typeof growthChainsConfig =
  env === "prod" ? "prod" : env === "beta" ? "beta" : "dev";

export const chainConfig = growthChainsConfig[chainConfigKey];
if (!clientId) {
  throw new Error("No client ID provided");
}
if (!secretKey) {
  throw new Error("No secret key provided");
}
if (!chainConfig) {
  throw new Error("No chain config provided");
}

export const thirdweb_client = createThirdwebClient({
  clientId,
  secretKey,
});

export const thirdweb_trexChain = defineChain(chainConfig[0]);
